import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_867a2d82: FaireBrandEntity = {
  token: "b_867a2d82",
  type: "brand",
  name: "Linn.",
  avatarUrl:
    "https://cdn.faire.com/fastly/c1c084c009d5902fe4db1489a250d7fec033db6e4dfcac28ea2d5afe543cb0ba.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/9cb8ffe0c0edb51d56af800a4382d44d217b2d302d576372bef383ed44086ddf.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/c1c084c009d5902fe4db1489a250d7fec033db6e4dfcac28ea2d5afe543cb0ba.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/9cb8ffe0c0edb51d56af800a4382d44d217b2d302d576372bef383ed44086ddf.jpeg",
  location: "Brooklyn, NY, USA",
  minimumOrderDollars: 1500,
  rating: 5,
  reviewCount: 2,
  isInsider: true,
  description:
    "Harmony in contrast - Refined forms, Raw texture.\n \nLinn. Fine Jewelry is a Brooklyn-based fine jewelry brand founded by designer Masumi Hayashi, who handcrafts each piece with an unwavering dedication to form, texture, and contrast. Raised in Sapporo, Japan, Masumi began her career as an accessory designer in Tokyo’s fashion world before relocating to New York in 2001. There, she learned traditional bench jewelry techniques from a master craftsman who had worked at Tiffany & Co., embracing the discipline and artistry of fine jewelry from the ground up.\nMasumi’s designs are guided by a deep fascination with contrast—the interplay between deliberate, geometric structures and the spontaneous, organic forms found in nature. Her work often features sharp silhouettes that cradle softly irregular gemstones, or precise cuts enveloped in richly textured gold. Each piece is a study in balance: controlled yet expressive, architectural yet fluid.\nThis design philosophy reflects her Japanese sensibility—an appreciation for subtle harmony and asymmetry—infused with the bold energy of New York and the diverse inspirations gathered through years of travel. The result is a collection that is at once refined and playful, designed to evoke curiosity, beauty, and quiet strength.\n",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:04.405Z",
    importedBy: "entity-db-cli",
  },
};
